import React, { useEffect, useState } from 'react';
import LinkAdaptativo from '../UI/LinkAdaptativo.js';
import CuadroDatos from '../UI/CuadroDatos.js';
import Paginador from '../UI/Paginador.js';
import TablaDatos from '../UI/TablaDatos.js';
import * as UI from '../constantes/UI.js';
import { ListaPartidos } from '../constantes/Filtros.js';
import * as Localia from '../constantes/Localia.js';
import * as DataPartidos from '../data/DataPartidos.js';
import * as Fecha from '../funciones/FuncionesFecha.js';
import {
  getIdRival,
  getIdTipoRival,
  getCategoriaIdRival,
} from '../funciones/FuncionesHistoriales.js';
import { NombreEquipoRelativo } from '../funciones/FuncionesEquipo.js';
import useGetListaURL from '../../hooks/useGetListaURL.js';
import styles from './PartidosClub.module.css';

const PartidosClub = (props) => {
  const idClub = props.club && props.club.id;
  const tipoRival = props.rival && getIdTipoRival(props.rival);
  const idRival = props.rival && getIdRival(props.rival);
  const idCategoria = props.rival && getCategoriaIdRival(props.rival);
  const filtro = props.filtro || ListaPartidos.TOTALES;
  const [partidos, setPartidos] = useState([]);
  const [cantPaginas, setCantPaginas] = useState(null);
  const [pagina, setPagina] = useState(0);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  // Resetear página cuando cambia el filtro
  useEffect(() => {
    setPagina(0);
  }, [filtro]);

  useEffect(() => {
    const getTotalPartidos = async () => {
      let total = await DataPartidos.GetTotalPartidosClub(
        idClub,
        filtro,
        tipoRival,
        idRival,
        idCategoria
      );
      if (total !== null && total !== Promise.resolve(total)) {
        setCantPaginas(Math.floor(total / UI.PARTIDOS_X_PAGINA) + 1);
      }
    };
    if (idClub !== null) {
      getTotalPartidos();
    }
  }, [fetchData, idClub, filtro, tipoRival, idRival, idCategoria]);

  useEffect(() => {
    if (idClub) {
      const idBusqueda = idRival ? idRival : idClub;
      const path = DataPartidos.PathClubTipoRival(idClub, tipoRival, idRival);
      if (path) {
        const url = DataPartidos.URLListaPartidos(
          path,
          idBusqueda,
          filtro,
          pagina,
          UI.PARTIDOS_X_PAGINA,
          idCategoria
        );
        fetchData(url, setPartidos);
      }
    } else {
      setPartidos([]);
    }
  }, [fetchData, idClub, filtro, tipoRival, idRival, pagina, idCategoria]);

  const onPaginaElegida = (pagina) => {
    setPagina(pagina);
  };

  const nombreRival = (partido) => {
    return partido.localia === Localia.LOCAL
      ? NombreEquipoRelativo(partido.equipoVisitante, partido.categoria, partido.equipoLocal.pais)
      : NombreEquipoRelativo(partido.equipoLocal, partido.categoria, partido.equipoVisitante.pais);
  };

  const condicionPartido = (partido) => {
    return partido.neutral ? Localia.NEUTRAL : partido.localia;
  };

  const resultadoPartido = (partido) => {
    if (partido.resultadoLocal === null || partido.resultadoVisitante === null) {
      return '-';
    } else if (partido.localia === Localia.LOCAL) {
      return partido.resultadoLocal + ' - ' + partido.resultadoVisitante;
    } else if (partido.localia === Localia.VISITANTE) {
      return partido.resultadoVisitante + ' - ' + partido.resultadoLocal;
    } else {
      return '-';
    }
  };

  return (
    <CuadroDatos titulo="Partidos" isCargando={isCargando} errores={erroresGetLista}>
      {partidos && !isCargando && (
        <React.Fragment>
          <TablaDatos
            estilo={`${styles.tablaPartidos}`}
            lista={partidos}
            textoVacia={
              idRival
                ? 'No hay partidos cargados entre los equipos'
                : 'No hay partidos cargados para el club'
            }
          >
            <tbody>
              <tr className={`${styles.titulo}`} key="0">
                <td className={`${styles.fecha}`}>Fecha</td>
                <td className={`${styles.torneo}`}>Torneo</td>
                <td className={`${styles.rival}`}>Rival</td>
                <td className={`${styles.condicion}`}>Cond.</td>
                <td className={`${styles.resultado}`}>Res.</td>
              </tr>
              {partidos &&
                partidos.map((partido) => (
                  <tr key={partido.id}>
                    <td>
                      {Fecha.CamposToFechaCorta(
                        partido.anioPartido,
                        partido.mesPartido,
                        partido.diaPartido
                      )}
                    </td>
                    <td>{partido.motivo}</td>
                    <td>{nombreRival(partido)}</td>
                    <td className={`${styles.condicion}`}>{condicionPartido(partido)}</td>
                    <td className={`${styles.resultado}`}>
                      <LinkAdaptativo to={'/partido/' + partido.id} external={true}>
                        {resultadoPartido(partido)}
                      </LinkAdaptativo>
                    </td>
                  </tr>
                ))}
            </tbody>
          </TablaDatos>
          <Paginador
            cantPaginas={cantPaginas}
            cantBotones="5"
            paginaActual={pagina}
            onPaginaElegida={onPaginaElegida}
          />
        </React.Fragment>
      )}
    </CuadroDatos>
  );
};

export default PartidosClub;
